<template>
  <div class="addroster">
    <div class="newsDetial-header">
      <div class="newsDetial-title">{{ title }}</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract" v-if="!id">
        请按照表单要求添加和修改数据
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">姓名 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.fullName"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">所在部门 <span class="required">*</span></span>
            <a-tree-select
              v-model="Form.organizationId"
              class="w300"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="请选择部门"
              tree-default-expand-all
              :replaceFields="replaceFields"
            >
            </a-tree-select>
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">身份证号 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.idCardNumber"
              @blur="idCardNumberBlur"
            />
          </a-descriptions-item>
          <a-descriptions-item label="出生年月" v-if="id">
            <a-date-picker
              class="w300"
              :valueFormat="dayFormat"
              v-model="Form.birthTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="民族">
            <a-input class="w300" placeholder="请添加" v-model="Form.nation" />
          </a-descriptions-item>
          <a-descriptions-item label="籍贯">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.nativePlace"
            />
          </a-descriptions-item>
          <a-descriptions-item label="出生地">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.birthplace"
            />
          </a-descriptions-item>
          <a-descriptions-item label="政治面貌">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.politicalType"
            >
              <a-select-option
                v-for="item in politicalTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item
            label="入党时间"
            v-if="Form.politicalType == 1500"
          >
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.joinPartyTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="户口所在地">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.registeredResidence"
            />
          </a-descriptions-item>
          <a-descriptions-item label="户口性质">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.registeredNature"
            >
              <a-select-option
                v-for="item in registeredNatureList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="健康状况">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.healthStatus"
            >
              <a-select-option
                v-for="item in healthStatusList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="联系电话"
            ><a-input-number
              class="w300"
              placeholder="请添加"
              v-model="Form.phone"
            />
          </a-descriptions-item>
          <a-descriptions-item label="家庭地址">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.homeAddress"
            />
          </a-descriptions-item>
          <a-descriptions-item label="员工编号">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.personalNumber"
            />
          </a-descriptions-item>
          <a-descriptions-item label="县区">
            <a-input class="w300" placeholder="请添加" v-model="Form.county" />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">学历信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="全日制教育学历">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.firstEducation"
            >
              <a-select-option
                v-for="item in educationList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="全日制教育学位">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.firstAcademicDegree"
            />
          </a-descriptions-item>
          <a-descriptions-item label="全日制教育专业">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.firstMajor"
            />
          </a-descriptions-item>

          <a-descriptions-item label="全日制教育毕业院校">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.firstGraduationSchool"
            />
          </a-descriptions-item>
          <a-descriptions-item label="在职教育学历">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.education"
            >
              <a-select-option
                v-for="item in educationList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item label="在职教育学位">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.academicDegree"
            />
          </a-descriptions-item>
          <a-descriptions-item label="在职教育专业">
            <a-input class="w300" placeholder="请添加" v-model="Form.major" />
          </a-descriptions-item>
          <a-descriptions-item label="在职教育毕业院校">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.graduationSchool"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">工作信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >行政职务
              <!-- <span class="required">*</span> -->
            </span>
            <a-select class="w300" placeholder="请添加" v-model="Form.position">
              <a-select-option
                v-for="item in positionList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >任现职务时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.positionTime"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label"
              >职级
              <!-- <span class="required">*</span> -->
            </span>
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.positionLevel"
            >
              <a-select-option
                v-for="item in positionLevelList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >任现职级时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.positionLevelTime"
            />
          </a-descriptions-item>

          <a-descriptions-item label="技术职称">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.technicalTitle"
            />
          </a-descriptions-item>
          <a-descriptions-item label="职称聘任时间">
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.appointmentTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="职称获得时间">
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.acquisitionTime"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >首次参加工作时间
              <span class="required">*</span>
            </span>
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.firstWorkTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="总工龄" v-if="id">
            <a-input-number
              v-model="totalSystemAgeYears"
              :min="0"
              :max="99"
              class="mr10"
              @blur="blur('1')"
            />年
            <a-input-number
              v-model="totalSystemAgeMonth"
              :min="0"
              :max="12"
              class="ml10"
              @blur="blur('2')"
            />月
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >进入本公司机关时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.currentOfficeSysTime"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label"
              >进入民政系统时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.civilOfficeSysTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="进入本公司系统时间">
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.headOfficeSysTime"
            />
          </a-descriptions-item>

          <a-descriptions-item label="军转干部/复原军人">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.militaryCadres"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">劳动合同信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >首次签订合同时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.firstSignContractTime"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >首次签订合同类型
              <!-- <span class="required">*</span> -->
            </span>
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.firstContractType"
              @change="contractTypeChange"
            >
              <a-select-option
                v-for="item in contractTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >首次签订合同年限
              <!-- <span class="required">*</span> -->
            </span>
            <a-input-number
              class="w300"
              placeholder="请添加"
              :min="0"
              :max="99999999999"
              v-model="Form.firstContractYears"
              :disabled="Form.firstContractType == 1101"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label"> 续订1合同时间</span>
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.secondSignContractTime"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">续订1合同类型</span>
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.secondContractType"
              @change="contractTypeChange1"
            >
              <a-select-option
                v-for="item in contractTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="续订1合同年限">
            <a-input-number
              class="w300"
              placeholder="请添加"
              :min="0"
              :max="99999999999"
              v-model="Form.secondContractYears"
              :disabled="Form.secondContractType == 1101"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label"> 续订2合同时间</span>
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.thirdSignContractTime"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">续订2合同类型</span>
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.thirdContractType"
              @change="contractTypeChange2"
            >
              <a-select-option
                v-for="item in contractTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="续订2合同年限">
            <a-input-number
              class="w300"
              placeholder="请添加"
              :min="0"
              :max="99999999999"
              v-model="Form.thirdContractYears"
              :disabled="Form.thirdContractType == 1101"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">退休信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >退休前职务
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.retirePosition"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >退休时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.retireTime"
            />
          </a-descriptions-item>

          <a-descriptions-item label="退休身份">
            <a-select
              class="w300"
              placeholder="请选择"
              v-model="Form.retireIdentity"
            >
              <a-select-option
                v-for="item in retireIdentityList"
                :value="item.keyname"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="退休类别">
            <a-select
              class="w300"
              placeholder="请选择"
              v-model="Form.retireType"
            >
              <a-select-option
                v-for="item in retireTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">退休人员档案号</span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.retireNumber"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">是否社会化管理</span>
            <a-select
              allowClear
              class="w300"
              placeholder="不限"
              v-model="Form.socialManagement"
            >
              <a-select-option
                v-for="(item, index) in socialManagementList"
                :value="item"
                :key="index"
              >
                {{ item }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">社会化社区名称</span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.socialName"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">退休备注</span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.description"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">紧急联系人<span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.emergencyContact"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">紧急联系人关系</span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.emergencyContactRelationship"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >紧急联系人电话<span class="required">*</span></span
            >
            <a-input-number
              class="w300"
              placeholder="请添加"
              v-model="Form.emergencyContactPhone"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="organizationId == 100101">
      <div class="detial-cont-title">开具材料情况</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <materialsTable
          v-model="Form.personnelManagerScienceList"
          :file="Form.personnelManagerScienceList"
          :id="id"
          :disabled="false"
        ></materialsTable>
      </div>
    </div>
    <bottomSuspension>
      <a-button :style="{ marginRight: '20px' }" @click="goback">
        返回
      </a-button>
      <a-button
        v-if="id"
        type="primary"
        :style="{ marginRight: '20px' }"
        @click="setpop()"
      >
        减员
      </a-button>
      <a-button
        type="primary"
        :loading="confirmLoading"
        :style="{ marginRight: '42px' }"
        @click="subMit"
      >
        提交
      </a-button>
    </bottomSuspension>
    <a-modal
      v-model="ispop"
      title="减员操作"
      @ok="handleOk"
      :confirm-loading="depLoading"
    >
      <prompts> 请选择减员原因，并填写减员备注信息，上传死亡档案</prompts>
      <div class="dep-form">
        <div class="dep-form-item">
          <div class="dep-form-lable">减员原因：</div>
          <a-radio-group v-model="delData.positionStatus">
            <template v-for="item in retirePositionStatus">
              <a-radio
                :value="item.valuename"
                :key="item.id"
                v-if="item.valuename !== '1001'"
              >
                {{ item.keyname }}
              </a-radio>
            </template>
          </a-radio-group>
        </div>
        <blank height="15"> </blank>
        <div class="dep-form-item">
          <div class="dep-form-lable">减员备注：</div>
        </div>
        <blank height="15"> </blank>
        <div class="dep-form-item">
          <a-input
            v-model="delData.cause"
            type="textarea"
            class="w500"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </div>
        <blank height="20"> </blank>
        <!-- 死亡档案：选择死亡才能看到 -->
        <div
          class="deathFileListContent"
          v-if="delData.positionStatus === '1003'"
        >
          <div class="dep-form-item">
            <div class="">死亡档案：<span class="required">*</span></div>
          </div>
          <div>
            <a-table
              v-show="
                delData.deathPersonnelManagerFileList &&
                  delData.deathPersonnelManagerFileList.length > 0
              "
              :showHeader="false"
              :pagination="false"
              :columns="columns"
              :data-source="delData.deathPersonnelManagerFileList"
              :row-key="record => record.mongoFileId"
            >
              <div slot="action" slot-scope="text, record">
                <a-button
                  type="link"
                  class="btn-link"
                  @click="goDetial(record)"
                >
                  查看
                </a-button>
                <a-divider type="vertical" />
                <a-button
                  type="link"
                  class="btn-link"
                  @click="removeFiles(record.mongoFileId)"
                >
                  删除
                </a-button>
              </div>
            </a-table>
          </div>
          <div class="accessory-btn">
            <a-upload
              name="file"
              :multiple="false"
              :headers="headers"
              action="#"
              :fileList="fileList"
              @change="uploadFiles"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
            >
              <a-button @click="fileList = []"
                ><a-icon type="upload" />上传死亡档案
              </a-button>
            </a-upload>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "档案名称",
    dataIndex: "filename",
    key: "filename",
    align: "left",
    width: 360
  },
  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 120
  }
];
import {
  personnelManagerRetirePersonnelGet,
  getTreeList,
  updateMfPositionStatus,
  personnelManagerSaveMfPersonnelManager,
  personnelManagerUpdatePersonnelMfManager
} from "../api/api";
import { mapState, mapActions } from "vuex";
import { validateIdCard } from "@/assets/js/auth.js";
import { kkFileUrl, fileUrlHOST } from "@/http/config";
import { saveFile, getFile } from "@/http/url";
import { getSuffix, formatDate } from "@/assets/js/auth";

import materialsTable from "../TheDead/components/materials-table.vue";
export default {
  components: {
    materialsTable
  },
  data() {
    return {
      columns,
      confirmLoading: false,
      title: "新建花名册信息",
      treeData: [], // 组织机构树
      replaceFields: {
        key: "id",
        value: "id",
        children: "treeList",
        title: "organizationName"
      },
      dayFormat: "YYYY.MM.DD",
      monthFormat: "YYYY.MM",
      Form: {},
      totalSystemAgeYears: "", //年
      totalSystemAgeMonth: "", //月
      id: "",
      delData: {
        deathPersonnelManagerFileList: [] //上传成功的死亡档案附件
      }, // 减员操作信息
      ispop: false, // 减员弹窗
      depLoading: false,
      retireIdentityList: [
        { id: 1, valuename: "001", keyname: "工人" },
        { id: 2, valuename: "002", keyname: "干部" }
      ], // 退休身份
      socialManagementList: ["是", "否"], // 是否社会化管理
      retirePositionStatus: [
        { valuename: "1003", keyname: "死亡" },
        { valuename: "1006", keyname: "失踪" }
      ], // 减员原因写死
      fileList: [],
      headers: {
        Authentication: localStorage.getItem("token")
      }
    };
  },
  created() {
    this.getByType();
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.id) {
      this.$route.meta.title = this.title = "修改花名册个人信息";
      personnelManagerRetirePersonnelGet(this.id).then(res => {
        if (res.data.code == 0) {
          this.Form = res.data.data;
          if (this.Form.totalSystemAge) {
            // 总工龄存在
            let yearIndex = this.Form.totalSystemAge.indexOf("年");
            let monthIndex = this.Form.totalSystemAge.indexOf("月");
            this.totalSystemAgeYears = this.Form.totalSystemAge.substring(
              0,
              yearIndex
            );
            this.totalSystemAgeMonth = this.Form.totalSystemAge.substring(
              yearIndex + 1,
              monthIndex
            );
          }
        }
      });
    }
  },
  computed: {
    organizationId() {
      return this.$store.state.app.userInfo.tenantId;
    },
    ...mapState({
      positionList: state => state.bytype.positionList, //行政职务
      positionLevelList: state => state.bytype.positionLevelList, //职级
      politicalTypeList: state => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: state => state.bytype.contractTypeList, //劳动合同类型
      educationList: state => state.bytype.educationList, //学历
      registeredNatureList: state => state.bytype.registeredNatureList, //户口性质
      healthStatusList: state => state.bytype.healthStatusList, //健康状态
      positionStatusList: state => state.bytype.positionStatusList, //减员原因
      // retirePositionStatus: (state) => state.bytype.retirePositionStatus, //退休减员原因
      retireTypeList: state => state.bytype.retireTypeList // 退休类别
    })
  },
  methods: {
    ...mapActions([
      "getposition",
      "getpositionLevel",
      "getpoliticalType",
      "getcontractType",
      "geteducation",
      "getregisteredNature",
      "gethealthStatus",
      "getpositionStatus",
      // 'getretirePositionStatus',
      "getRetireTypeList"
    ]),
    blur(type) {
      if (type == 1) {
        this.totalSystemAgeYears = parseInt(this.totalSystemAgeYears);
      }
      if (type == 2) {
        this.totalSystemAgeMonth = parseInt(this.totalSystemAgeMonth);
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //获取组织机构
      getTreeList().then(res => {
        this.treeData = res.data.data;
      });
      //行政职务
      this.getposition();
      //职级
      this.getpositionLevel();
      //政治面貌
      this.getpoliticalType();
      //劳动合同类型
      this.getcontractType();
      //学历
      this.geteducation();
      //户口性质
      this.getregisteredNature();
      //健康状态
      this.gethealthStatus();
      //减员原因
      this.getpositionStatus();
      // 退休类别
      this.getRetireTypeList();
    },
    contractTypeChange(e) {
      //选择合同类型
      if (e == "1101") {
        //无固定期限
        this.$set(this.Form, "firstContractYears", "长期");
      } else {
        this.$set(this.Form, "firstContractYears", "");
      }
    },
    contractTypeChange1(e) {
      //选择合同类型
      if (e == "1101") {
        //无固定期限
        this.$set(this.Form, "secondContractYears", "长期");
      } else {
        this.$set(this.Form, "secondContractYears", "");
      }
    },
    contractTypeChange2(e) {
      //选择合同类型
      if (e == "1101") {
        //无固定期限
        this.$set(this.Form, "thirdContractYears", "长期");
      } else {
        this.$set(this.Form, "thirdContractYears", "");
      }
    },
    subMit() {
      // 点击提交
      if (!this.Form.fullName) {
        this.$message.error("请填写姓名");
        return;
      }
      if (!this.Form.idCardNumber) {
        this.$message.error("请填写身份证号");
        return;
      }
      if (!this.Form.organizationId) {
        this.$message.error("请选择所在部门");
        return;
      }
      if (!this.Form.firstWorkTime) {
        this.$message.error("请选择首次参加工作");
        return;
      }
      // if (!this.Form.civilOfficeSysTime) {
      //   this.$message.error('请选择进入民政系统时间')
      //   return
      // }
      if (!this.Form.emergencyContact) {
        this.$message.error("请填写紧急联系人");
        return;
      }
      if (!this.Form.emergencyContactPhone) {
        this.$message.error("请填写紧急联系人电话");
        return;
      }
      this.confirmLoading = true;
      if (this.id) {
        // 修改 ,
        this.Form.totalSystemAge =
          this.totalSystemAgeYears + "年" + this.totalSystemAgeMonth + "月";
        // 民福修改
        personnelManagerUpdatePersonnelMfManager(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.goback();
            this.confirmLoading = false;
          } else {
            this.confirmLoading = false;
          }
        });
      } else {
        //添加
        this.Form.positionStatus = 1004;
        // 民福添加
        personnelManagerSaveMfPersonnelManager(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.goback();
            this.confirmLoading = false;
          } else {
            this.confirmLoading = false;
          }
        });
      }
    },
    goback() {
      this.$router.push("/TheRetiree");
    },
    idCardNumberBlur() {
      if (!this.Form.idCardNumber) return;
      let n = validateIdCard(this.Form.idCardNumber);
      if (!n) {
        this.Form.idCardNumber = "";
        this.$message.error("身份证号格式错误");
      }
    },
    setpop() {
      this.ispop = true;
    },
    handleOk(e) {
      // 确定减员
      this.depLoading = true;
      let params = this.delData;
      params.id = this.id;
      updateMfPositionStatus(params).then(res => {
        if (res.data.code == 0) {
          this.$message.success("减员操作成功");
          this.ispop = false;
          this.goback();
          this.depLoading = false;
        } else {
          this.depLoading = false;
        }
      });
    },
    beforeUpload() {
      return false;
    },
    // 时间格式化
    formatDateIt(data) {
      return formatDate(data);
    },
    // 查看
    goDetial(item) {
      if (item.fileformat == "bpmn") {
        this.$message.error("该文件类型(bpmn)系统暂时不支持在线预览");
      } else {
        // window.open(item.kkFileUrl + encodeURIComponent(item.fileUrl))
        let Base64 = require("js-base64").Base64;
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        );
      }
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error("上传文件不得大于10M！");
      } else {
        this.saveFileFn(file.file);
      }
    },
    // 移除
    removeFiles(id) {
      this.$confirm({
        title: "确定删除吗?",
        okType: "danger",
        onOk: () => {
          let index = this.delData.deathPersonnelManagerFileList.findIndex(
            item => item.mongoFileId == id
          );
          this.delData.deathPersonnelManagerFileList.splice(index, 1);
          this.$message.success("删除成功");
        }
      });
    },
    // 上传文件
    saveFileFn(file) {
      const formDataChildren = new FormData();
      formDataChildren.append("file", file);
      this.$message.loading("上传中···", 0);
      saveFile(formDataChildren).then(res => {
        if (res.data.code == 0) {
          this.$message.destroy();
          this.$message.success("上传成功");
          let fileData = {};
          let SuffixArray = getSuffix(file.name);
          fileData.filename = SuffixArray[1];
          fileData.fileformat = SuffixArray[0];
          fileData.mongoFileId = res.data.data;
          fileData.kkFileUrl = kkFileUrl;
          fileData.fileUrl =
            fileUrlHOST +
            "mongo/kkFile?fileId=" +
            fileData.mongoFileId +
            "&fullfilename=" +
            SuffixArray[2];

          fileData.createTime = this.formatDateIt(new Date());
          this.delData.deathPersonnelManagerFileList.push(fileData);
        } else {
          this.$message.error("上传失败");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addroster {
  .newsDetial-header {
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
    }
  }
}
.dep-form {
  width: 468px;
  margin-top: 40px;
  .dep-form-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .dep-form-lable {
      width: 70px;
      height: 21px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      line-height: 21px;
      text-align: left;
    }
  }
  .operating-checkbox-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.accessory-btn {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheRetiree/add.vue